export class ContactUs {
  public name: string;
  public email: string;
  public phone: string;
  public comment: string;
}
